import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { RvBreadcrumb } from "../components/RvBreadcrumb";
import { RvExplainer } from "../components/RvExplainer";
import { TextReverseTool } from "../components/TextReverseTool";

export function TextReversePage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8">
        <RvBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.rv_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.rv_intro()}
          </p>
        </header>

        <TextReverseTool />

        <RvExplainer
          howTo={m.rv_howto()}
          faqs={[
            { q: m.rv_faq1_q(), a: m.rv_faq1_a() },
            { q: m.rv_faq2_q(), a: m.rv_faq2_a() },
            { q: m.rv_faq3_q(), a: m.rv_faq3_a() },
            { q: m.rv_faq4_q(), a: m.rv_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
